import React from "react";
import styles from "./Header.module.css";
import CommonStyles from "../InputFieldsController/InputFieldsController.module.css";
import {
  FieldProps,
  getFieldContainerStyle,
} from "../InputFieldsController/InputFieldsController.utils";

interface HeaderProps {
  field: FieldProps;
  handleSelect: (id: string) => void;
}

/**
 * Header renders a non-input title or section heading.
 * Supports layout and optional styling based on `headerSize`.
 *
 * @component
 * @param {Object} props - Component props
 * @param {FieldProps} props.field - Field config, including label and optional header size
 */
const Header: React.FC<HeaderProps> = ({ field, handleSelect }) => {
  const { label, show = true, headerSize = "h5" } = field;

  if (!show || !label) return null;

  const containerStyle = getFieldContainerStyle(field);
  const HeadingTag = headerSize as keyof JSX.IntrinsicElements;

  return (
    <div style={containerStyle} onClick={() => handleSelect(field.id)}>
      <HeadingTag>{label}</HeadingTag>
    </div>
  );
};

export default Header;
